export const GUEST_BOND_OPTIONS = [
  { title: "Probate Bond", path: "/vermost-probate-bond-request-guest", description: "Start a Probate bond request." },
  { title: "Guardianship Bond", path: "/vermost-guardianship-bond-request-guest", description: "Start a Guardianship bond request." },
  { title: "Trustee Bond", path: "/vermost-trustee-bond-request-guest", description: "Start a Trustee bond request." },
  { title: "VA Bond", path: "/vermost-va-bond-request-guest", description: "Start a VA bond request." },
  { title: "Blanket Bond", path: "/vermost-blanket-bond-request-guest", description: "Start a Blanket bond request." },
];
